import AsyncCallHandler from "../common/AsyncCallHandler";
import ACTION_TYPES from "./actionTypes";
import NEXUS_CONST from "../common/constants";
import { set, get } from "../common/utils";
import { alert } from "devextreme/ui/dialog";
import { postUserLog } from "../actions/common";

export const fetchSiteList = (dispatch, tier) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_SITE_LIST + tier, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_SITE_LIST, payload: res.data });
    }
  );
};

export const updateSiteData = (dispatch, data, props, flag) => {
  AsyncCallHandler(NEXUS_CONST.UPDATE_SITE_DATA, NEXUS_CONST.POST, data).then(
    (res) => {
      if (res) {
        if (flag) fetchSiteLists(dispatch);
        else fetchSiteList(dispatch, props);
      }
    }
  );
};

export const deleteSite = (dispatch, id, tier, flag) => {
  AsyncCallHandler(NEXUS_CONST.DELETE_SITE + id, NEXUS_CONST.POST).then(
    (res) => {
      if (flag) fetchSiteLists(dispatch);
      else fetchSiteList(dispatch, tier);
    }
  );
};

export const fetchPeopleList = (dispatch, siteId) => {
  AsyncCallHandler(NEXUS_CONST.GET_PEOPLE_DATA + siteId, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.GET_PEOPLE_DATA, payload: res.data });
    }
  );
};

export const updatePeople = (dispatch, data, tier) => {
  AsyncCallHandler(NEXUS_CONST.UPDATE_PEOPLE, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchPeopleList(dispatch, tier);
    }
  );
};

export const deletePeople = (dispatch, id, tier) => {
  AsyncCallHandler(NEXUS_CONST.DELETE_PEOPLE + id, NEXUS_CONST.POST).then(
    (res) => {
      fetchPeopleList(dispatch, tier);
    }
  );
};

export const fetchScheduleReportData = (dispatch, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_SCHEDULED_REPORT + siteId,
    NEXUS_CONST.GET
  ).then((res) => {
    // fetchPeopleList(dispatch, tier);
    dispatch({ type: ACTION_TYPES.FETCH_SCHEDULED_REPORT, payload: res.data });
  });
};

export const fetchScheduleReportTierListData = (dispatch, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_SCHEDULED_REPORT_LIST_DATA + siteId,
    NEXUS_CONST.GET
  ).then((res) => {
    // fetchPeopleList(dispatch, tier);
    dispatch({
      type: ACTION_TYPES.FETCH_SCHEDULED_REPORT_LIST_DATA,
      payload: res.data,
    });
  });
};

export const updateScheduleReportData = (dispatch, input, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.MANAGE_SCHEDULED_REPORT,
    NEXUS_CONST.POST,
    input
  ).then((res) => {
    fetchScheduleReportData(dispatch, siteId);
  });
};

export const deleteScheduleReportData = (dispatch, teirId, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.DELETE_SCHEDULE_REPORT_DATA + teirId,
    NEXUS_CONST.POST
  ).then((res) => {
    fetchScheduleReportData(dispatch, siteId);
  });
};

export const fetchReasonCodeList = (dispatch, siteId) => {
  AsyncCallHandler(
    "ReasonCodeRevamp/GetReasonCodeBySite?SiteID=" + siteId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_REASON_CODE_LIST, payload: res.data });
  });
};

export const updateReasonCode = (dispatch, data, tier) => {
  AsyncCallHandler(
    "ReasonCodeRevamp/ManageReasoncode",
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    fetchReasonCodeList(dispatch, tier);
  });
};

export const deleteReasonCode = (dispatch, id, tier) => {
  AsyncCallHandler(NEXUS_CONST.DELETE_REASON_CODE + id, NEXUS_CONST.POST).then(
    (res) => {
      fetchReasonCodeList(dispatch, tier);
    }
  );
};

export const fetchReasonCodeListforAdmin = (dispatch) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_REASON_CODE_LIST_FORADMIN).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_REASON_CODE_LIST_FORADMIN,
      payload: res.data,
    });
  });
};

export const updateReasonCodeforadminconsole = (dispatch, data) => {
  AsyncCallHandler(
    NEXUS_CONST.UPDATE_REASON_CODE_FORADMINCONSOLE,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    fetchReasonCodeListforAdmin(dispatch);
  });
};

export const deleteReasonCodeforAdminConsole = (dispatch, id) => {
  AsyncCallHandler(
    NEXUS_CONST.DELETE_REASON_CODE_FORADMINCONSOLE + id,
    NEXUS_CONST.POST
  ).then((res) => {
    fetchReasonCodeListforAdmin(dispatch);
  });
};

export const fetchVizualization = (dispatch, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_VIZUALIZATION + siteId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_VIZUALIZATION, payload: res.data });
  });
};

export const updateVizualization = (dispatch, data, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.UPDATE_VIZUALIZATION,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    fetchVizualization(dispatch, tier);
  });
};

export const deleteVizualization = (dispatch, id, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.DELETE_VIZUALIZATION + id,
    NEXUS_CONST.POST
  ).then((res) => {
    fetchVizualization(dispatch, tier);
  });
};

export const fetchTiers = (dispatch, siteId) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_TIER_LIST + siteId, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_TIER_LIST, payload: res.data });
    }
  );
};

export const fetchTiersAbove = (dispatch, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_ABOVE_TIER_LIST + siteId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_ABOVE_TIER_LIST, payload: res.data });
  });
};

export const updateTiers = (dispatch, data, tier) => {
  AsyncCallHandler(NEXUS_CONST.MANAGE_TIER, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchTiers(dispatch, tier);
    }
  );
};

export const deleteTier = (dispatch, id, tier) => {
  AsyncCallHandler(NEXUS_CONST.DELETE_TIER + id, NEXUS_CONST.POST).then(
    (res) => {
      fetchTiers(dispatch, tier);
    }
  );
};

export const fetchGembaTypes = (dispatch, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_GEMBA_TYPES + siteId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_GEMBA_TYPES, payload: res.data });
  });
};

export const deleteGembaType = (dispatch, id, tier) => {
  AsyncCallHandler(NEXUS_CONST.DEL_GEMBA_TYPE + id, NEXUS_CONST.POST).then(
    (res) => {
      fetchGembaTypes(dispatch, tier);
    }
  );
};
export const fetchIncidentTypeList = (dispatch, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_INCIDENT_TYPE_LIST + siteId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_INCIDENT_TYPE_LIST,
      payload: res.data,
    });
  });
};

export const updateIncidentType = (dispatch, data, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.UPDATE_INCIDENT_TYPE,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    fetchIncidentTypeList(dispatch, tier);
  });
};

export const updateGembaType = (dispatch, data, siteId) => {
  AsyncCallHandler(NEXUS_CONST.UPDATE_GEMBA_TYPE, NEXUS_CONST.POST, data).then(
    (res) => {
      fetchGembaTypes(dispatch, siteId);
    }
  );
};
export const deleteIncidentType = (dispatch, id, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.DELETE_INCIDENT_TYPE + id,
    NEXUS_CONST.POST
  ).then((res) => {
    fetchIncidentTypeList(dispatch, siteId);
  });
};

export const fetchCalendarEventTypes = (dispatch, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_CALENDAR_EVENT_TYPES + siteId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_CALENDAR_EVENT_TYPES,
      payload: res.data,
    });
  });
};

export const updateCalendarEventType = (dispatch, data, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.UPDATE_CALENDAR_EVENT_TYPE,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    fetchCalendarEventTypes(dispatch, siteId);
  });
};
export const deleteCalendarEventType = (dispatch, id, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.DEL_CALENDAR_EVENT_TYPE + id,
    NEXUS_CONST.POST
  ).then((res) => {
    fetchCalendarEventTypes(dispatch, siteId);
  });
};
export const getHse = (dispatch, site) => {
  AsyncCallHandler(
    "settings/GetHSECommunicationTasksList?siteId=" + site,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_HSE, payload: res.data });
  });
};

export const updateHse = (dispatch, data, site) => {
  AsyncCallHandler(
    "settings/manageHSECommunicationTasks",
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    getHse(dispatch, site);
  });
};

export const delHse = (dispatch, id, site) => {
  AsyncCallHandler(
    "settings/deleteHSECommTasks?id=" + id,
    NEXUS_CONST.POST
  ).then((res) => {
    getHse(dispatch, site);
  });
};
export const fetchSiteLists = (dispatch, url) => {
  AsyncCallHandler("settings/getSiteListData", NEXUS_CONST.GET).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_SITE_LISTS, payload: res.data });
  });
};

export const fetchUserDetails = (dispatch, employeeId) => {
  AsyncCallHandler(
    NEXUS_CONST.GET_USER_DETAILS + employeeId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.GET_USER_DETAILS, payload: res.data });
  });
};

export const fetchOPHMissReasonCodes = (dispatch, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_OPH_MISS_REASON_CODES + siteId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_OPH_MISS_REASON_CODES,
      payload: res.data,
    });
  });
};

export const updateOPHMissReasonCodes = (dispatch, data, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.UPDATE_OPH_MISS_REASON_CODES,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    fetchOPHMissReasonCodes(dispatch, tier);
  });
};

export const deleteOPHMissReasonCodes = (dispatch, id, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.DELETE_OPH_MISS_REASON_CODES + id,
    NEXUS_CONST.POST
  ).then((res) => {
    fetchReasonCodeList(dispatch, tier);
  });
};

export const fetchShifts = (dispatch, qry) => {
  AsyncCallHandler(
    "settings/getShiftScheduleData?siteid=" + qry,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_SHIFT_LIST, payload: res.data });
  });
};

export const manageShifts = (dispatch, data, qry) => {
  dispatch({ type: "SAVE_MAT_SHIFT_ERR", payload: null });
  AsyncCallHandler(
    "settings/manageShiftScheduleData",
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    if (res.data == "24") {
      dispatch({ type: "SAVE_MAT_SHIFT_ERR", payload: "24" });
    } else if (res.data == "BreakOutOff") {
      dispatch({ type: "SAVE_MAT_SHIFT_ERR", payload: "breakOutRange" });
    } else if (res.data == "BreakOverlap") {
      dispatch({ type: "SAVE_MAT_SHIFT_ERR", payload: "breakOverlap" });
    } else if (res.data == "overlap") {
      dispatch({ type: "SAVE_MAT_SHIFT_ERR", payload: "overlap" });
    } else if (res.data == "DateValidation") {
      dispatch({ type: "SAVE_MAT_SHIFT_ERR", payload: "dateValidation" });
    } else {
      let details = data;
      details["shift"] = [];
      dispatch({ type: "FETCH_MAT_SHIFT_LIST", payload: details });
      dispatch({ type: "SAVE_MAT_SHIFT_ERR", payload: "saved" });
      fetchMatShifts(dispatch, qry);
    }
  });
};

export const fetchMatShifts = (dispatch, qry) => {
  AsyncCallHandler(
    "Settings/getMatDetShiftScheduleData?tierId=" + qry,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_MAT_SHIFT_LIST", payload: res.data });
  });
};

export const fetchLIDandPlantData = (dispatch, sbg, tier) => {
  AsyncCallHandler(
    "AdminConsole/GetAllLidPlantList?SBGId=" + sbg + "&TierLevel=" + tier,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.GET_LID_PLANT_DATA, payload: res.data });
  });
};

export const fetchSmessReasonCodeListforAdmin = (dispatch) => {
  AsyncCallHandler(NEXUS_CONST.FETCH_SMESS_REASON_CODE_LIST_FORADMIN).then(
    (res) => {
      dispatch({
        type: ACTION_TYPES.FETCH_SMESS_REASON_CODE_LIST_FORADMIN,
        payload: res.data,
      });
    }
  );
};

export const updateSMESSReasonCodeforadminconsole = (dispatch, data) => {
  AsyncCallHandler(
    NEXUS_CONST.UPDATE_SMESS_REASON_CODE_FORADMINCONSOLE,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    fetchSmessReasonCodeListforAdmin(dispatch);
  });
};

export const deleteSMESSReasonCodeforAdminConsole = (dispatch, id) => {
  AsyncCallHandler(
    NEXUS_CONST.DELETE_SMESS_REASON_CODE_FORADMINCONSOLE + id,
    NEXUS_CONST.POST
  ).then((res) => {
    fetchReasonCodeListforAdmin(dispatch);
  });
};

export const fetchLinesInfo = (dispatch, siteID) => {
  AsyncCallHandler(NEXUS_CONST.GET_SITE_LINES + siteID, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.FETCH_LINES_LIST, payload: res.data });
    }
  );
};
// JIRA NEX-1636 Start
export const featchMaterialDetailsBytierId = (dispatch, TierID) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_MATERIAL_LIST + TierID,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_MATERIAL_LIST, payload: res.data });
  });
};

export const fetchTimezoneInfo = (dispatch) => {
  AsyncCallHandler(NEXUS_CONST.GET_TIMEZONE_LIST, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: ACTION_TYPES.GET_TIMEZONE_LIST, payload: res.data });
    }
  );
};

export const mangeMaterialDetails = (dispatch, data, tier, siteId) => {
  AsyncCallHandler(
    NEXUS_CONST.MANAGE_MATERIALDATA,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    featchMaterialDetailsBytierId(dispatch, tier);
  });
};

export const manageBulkMaterialDetails = (dispatch, data, tier) => {
  AsyncCallHandler(
    NEXUS_CONST.MANAGE_BULK_MATERIAL_DATA,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    if (res) {
      dispatch({
        type: ACTION_TYPES.FETCH_BULK_MATERIAL_LIST,
        payload: res.data,
      });
      featchMaterialDetailsBytierId(dispatch, tier);
    }
  });
};
// JIRA NEX-1636 END

export const fetchMatShiftList = (dispatch, qry) => {
  AsyncCallHandler(
    "Settings/getShiftSummaryData?tierId=" + qry,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "FETCH_MAT_SHIFTS_LIST_DATA", payload: res.data });
  });
};

export const deleteShiftInfo = (dispatch, id, tier) => {
  AsyncCallHandler(
    `Settings/deleteShiftScheduleData?id=${id}&tierId=${tier}`,
    NEXUS_CONST.POST
  ).then((res) => {
    fetchMatShiftList(dispatch, tier);
    dispatch({ type: "FETCH_MAT_SHIFT_DELETE", payload: res.data });
  });
};

export const getSiteInfo = (dispatch, prop) => {
  AsyncCallHandler(NEXUS_CONST.GET_TIER_INFO + prop, NEXUS_CONST.GET).then(
    (res) => {
      dispatch({ type: "SITE_TIME_INFO", payload: res.data });
    }
  );
};

export const fetchSettingsMultiSurveyData = (dispatch, parentTierID) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_SETTINGS_MULTI_SURVEY_DATA + parentTierID,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.FETCH_SETTINGS_MULTI_SURVEY_DATA,
      payload: res.data,
    });
  });
};

export const manageSettingsMultiSurveyData = async (dispatch, data, siteId) => {
  try {
    const res = await AsyncCallHandler(
      NEXUS_CONST.MANAGE_SETTINGS_MULTI_SURVEY_DATA,
      NEXUS_CONST.POST,
      data
    );
    fetchSettingsMultiSurveyData(dispatch, siteId);
  } catch (error) {
    const { surveyName } = data;
    const resError = error?.response?.data;

    if (
      ["duplicate key", "unique key", "duplicate"].some((keyword) =>
        resError.toLowerCase().includes(keyword)
      )
    ) {
      alert(`Survey Name - "${surveyName}" already exists`, "Alert");
    }
    fetchSettingsMultiSurveyData(dispatch, siteId);
  }
};

export const removeSettingsMultiSurveyData = (
  dispatch,
  surveyId,
  parentTierID
) => {
  AsyncCallHandler(
    NEXUS_CONST.REMOVE_SETTINGS_MULTI_SURVEY_DATA + surveyId,
    NEXUS_CONST.POST,
    surveyId
  ).then((res) => {
    if (res) {
      fetchSettingsMultiSurveyData(dispatch, parentTierID);
    }
  });
};

export const fetchSettingsMultiSurveyTiersData = (dispatch, surveyId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_SETTINGS_MULTI_SURVEY_TIERS_DATA + surveyId,
    NEXUS_CONST.GET
  ).then((res) => {
    if (res) {
      dispatch({
        type: ACTION_TYPES.FETCH_SETTINGS_MULTI_SURVEY_TIERS_DATA,
        payload: res.data,
      });
    }
  });
};

export const manageSettingsMultiSurveyTiersData = (dispatch, data) => {
  AsyncCallHandler(
    NEXUS_CONST.MANAGE_SETTINGS_MULTI_SURVEY_TIERS_DATA,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    if (res) {
      fetchSettingsMultiSurveyTiersData(dispatch, data.SurveyID);
    }
  });
};

export const fetchSurveyQuestionData = (dispatch, surveyId) => {
  AsyncCallHandler(
    NEXUS_CONST.FETCH_QUESTIONS_SURVEY + surveyId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_QUESTIONARE_DATA, payload: res.data });
  });
};

export const manageSurveyQuestionsData = (dispatch, data, surveyId) => {
  AsyncCallHandler(
    NEXUS_CONST.MANAGE_SURVEY_QUESTIONS_DATA,
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    if (res) {
      fetchSurveyQuestionData(dispatch, surveyId);
    }
  });
};

export const fetchUserPref = (dispatch, props) => {
  AsyncCallHandler(
    "Home/getGridCustomization?tierid" + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "USER_PREF_SETTINGS", payload: res.data });
  });
};
export const updateUserPref = (dispatch, data) => {
  AsyncCallHandler("Home/ManageGridCustomData", NEXUS_CONST.POST, data).then(
    (res) => {
      //data saved!
    }
  );
};

export const fetchLanguagesByRegion = (dispatch, props) => {
  AsyncCallHandler(
    "ReasonCodeRevamp/GetLanguagesByRegion" + props,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.GET_LANGUAGES_BY_REGION, payload: res.data });
  });
};

export const fetchInputTypeReasonCodeByLangID = (dispatch, languageId) => {
  AsyncCallHandler(
    "ReasonCodeRevamp/GetInputTypeReasonCodeByLangID?LanguageID=" + languageId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({
      type: ACTION_TYPES.GET_INPUT_TYPE_REASON_CODE_BY_LANG_ID,
      payload: res.data,
    });
  });
};

export const Manage6MInputTypeData = (dispatch, payload) => {
  AsyncCallHandler(
    "ReasonCodeRevamp/ManageInputTypeData",
    NEXUS_CONST.POST,
    payload
  )
    .then((res) => {
      fetchInputTypeReasonCodeByLangID(dispatch, payload.languageID);
      dispatch({
        type: ACTION_TYPES.SEND_TOAST_MESSAGE,
        payload: {
          type: "success",
          message: "Updated Successfully",
        },
      });
    })
    .catch((e) => {
      fetchInputTypeReasonCodeByLangID(dispatch, payload.languageID);
      dispatch({
        type: ACTION_TYPES.SEND_TOAST_MESSAGE,
        payload: {
          type: "error",
          message: "Something went wrong while updating",
        },
      });
    });
};
export const fetchLanguage = (dispatch) => {
  AsyncCallHandler(
    "ReasonCodeRevamp/GetLanguagesByRegion",
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: ACTION_TYPES.FETCH_LANGUAGE, payload: res.data });
  });
};

export const manageLanguageData = (dispatch, data) => {
  AsyncCallHandler(NEXUS_CONST.MANAGE_LANGDATA, NEXUS_CONST.POST, data).then(
    (res) => {
      if (res) {
        fetchLanguage(dispatch);
      }
    }
  );
};

export const fetchLvl0 = (dispatch, siteId) => {
  AsyncCallHandler(
    "ReasonCodeRevamp/GetLevel0ReasonCodeBySiteUID?SiteUID=" + siteId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "LEVEL_0_LIST", payload: res.data });
  });
};

export const fetchRSTiers = (dispatch, siteId) => {
  AsyncCallHandler(
    "ReasonCodeRevamp/GetTierListByReason?SiteID=" + siteId,
    NEXUS_CONST.GET
  ).then((res) => {
    dispatch({ type: "REASON_CODE_TIERS", payload: res.data });
  });
};

export const saveTiersForReason = (dispatch, data) => {
  AsyncCallHandler(
    "ReasonCodeRevamp/ManageReasonTierData",
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    //fetchTiers(dispatch, tier);
  });
};

export const exportData = (url, name, inputData = null) => {
  AsyncCallHandler(url, NEXUS_CONST.POST, inputData, NEXUS_CONST.BLOB).then(
    (res) => {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name + ".xlsx");
      document.body.appendChild(link);
      link.click();
    }
  );
};

export const importReasonCodes = (dispatch, data, siteId) => {
  dispatch({ type: "REASON_CODES_IMPORT", payload: null });
  AsyncCallHandler(
    "ReasonCodeRevamp/ManageImportReasonData",
    NEXUS_CONST.POST,
    data
  ).then((res) => {
    dispatch({ type: "REASON_CODES_IMPORT", payload: res.data });
    fetchReasonCodeList(dispatch, siteId);
  }).catch(function (error) {
    dispatch({ type: "REASON_CODES_IMPORT", payload: "err" });
  });
};